import { getHttpVersion } from '@shared/http/utils/get-http-version';
import { ContentScriptStore } from '../store';
import { postToBackend } from '../utils';

export function handleWindowLoaded(): void {
  window.addEventListener('load', onLoaded);
}

export function removeWindowLoadedHandler(): void {
  window.removeEventListener('load', onLoaded);
}

async function onLoaded(): Promise<void> {
  const htmlElements = document.getElementsByTagName('html');
  if (!htmlElements) {
    return
  };
  const store = ContentScriptStore.getInstance();
  for (const element of Array.from(htmlElements)) {
    const html = element.outerHTML;

    await postToBackend({
      pageUrl: window.location.href,
      request: {
        httpVersion: getHttpVersion(),
        url: window.location.href,
      },
      response: {
        body: html,
        contentType: 'text/html',
        dateTime: new Date().toISOString(),
      },
      app: store.learningApp$.value,
    });
  }
}
